/* rp-redesign.js
   Draft theme only. Powers the size chips, quick add and filter bar on the
   new rp-* sections. No Dawn-owned file is edited.
*/
(function () {
  'use strict';

  if (window.__rpRedesign) return;
  window.__rpRedesign = true;

  /* ---- size chips ------------------------------------------------ */

  function selectVariant(card, btn) {
    card.querySelectorAll('.rp-size').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b === btn));
    });
    var price = card.querySelector('.rp-price');
    var add = card.querySelector('.rp-add');
    if (price) {
      price.textContent = '';
      if (btn.dataset.comparetext) {
        var s = document.createElement('s');
        s.textContent = btn.dataset.comparetext;
        price.appendChild(s);
      }
      price.appendChild(document.createTextNode(btn.dataset.pricetext || ''));
    }
    /* Swap the card photo when the chosen size has its own image in Shopify.
       The original src and srcset are stashed the first time so going back to a
       size with no image of its own restores the product photo rather than
       leaving the last one showing. */
    var img = card.querySelector('.rp-card-media img');
    if (img) {
      if (img.dataset.rpBaseSrc === undefined) {
        img.dataset.rpBaseSrc = img.getAttribute('src') || '';
        img.dataset.rpBaseSrcset = img.getAttribute('srcset') || '';
      }
      var want = btn.dataset.image || '';
      if (want) {
        img.removeAttribute('srcset');
        img.setAttribute('src', want);
      } else {
        if (img.dataset.rpBaseSrcset) img.setAttribute('srcset', img.dataset.rpBaseSrcset);
        if (img.dataset.rpBaseSrc) img.setAttribute('src', img.dataset.rpBaseSrc);
      }
    }

    if (add) {
      var available = btn.dataset.available === 'true';
      add.dataset.variant = btn.dataset.variant;
      add.disabled = !available;
      add.textContent = available ? 'Add' : 'Sold out';
      add.dataset.state = '';
    }
  }

  /* ---- quick add ------------------------------------------------- */

  function cartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function quickAdd(add) {
    var id = add.dataset.variant;
    if (!id || add.disabled) return;
    var original = add.textContent;
    add.disabled = true;
    add.textContent = 'Adding';

    var body = { items: [{ id: Number(id), quantity: 1 }] };
    var drawer = cartDrawer();
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        add.dataset.state = 'added';
        add.textContent = 'Added';
        if (drawer && drawer.renderContents) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          document.dispatchEvent(new CustomEvent('rp:cart:added'));
        }
        setTimeout(function () {
          add.dataset.state = '';
          add.textContent = original;
          add.disabled = false;
        }, 1800);
      })
      .catch(function () {
        add.textContent = 'Try again';
        add.disabled = false;
      });
  }

  /* ---- filter bar ------------------------------------------------ */

  function applyFilters(bar) {
    var scope = document.getElementById(bar.dataset.target);
    if (!scope) return;
    var active = {};
    bar.querySelectorAll('.rp-filter[aria-pressed="true"]').forEach(function (b) {
      if (b.dataset.value === '*') return;
      (active[b.dataset.key] = active[b.dataset.key] || []).push(b.dataset.value);
    });
    var shown = 0;
    scope.querySelectorAll('[data-rp-item]').forEach(function (item) {
      var ok = Object.keys(active).every(function (k) {
        var have = (item.dataset[k] || '').split('|');
        return active[k].some(function (v) { return have.indexOf(v) > -1; });
      });
      item.hidden = !ok;
      if (ok) shown++;
    });
    var out = bar.querySelector('.rp-result');
    if (out) out.textContent = shown + (shown === 1 ? ' product' : ' products');
    var empty = scope.parentElement.querySelector('.rp-empty');
    if (empty) empty.hidden = shown > 0;
  }

  /* ---- delegation ------------------------------------------------ */

  document.addEventListener('click', function (e) {
    var size = e.target.closest('.rp-size');
    if (size && !size.disabled) {
      e.preventDefault();
      selectVariant(size.closest('.rp-card'), size);
      return;
    }
    var add = e.target.closest('.rp-add');
    if (add) {
      e.preventDefault();
      quickAdd(add);
      return;
    }
    var filter = e.target.closest('.rp-filter');
    if (filter) {
      e.preventDefault();
      var pressed = filter.getAttribute('aria-pressed') === 'true';
      if (filter.dataset.value === '*') {
        filter.parentElement.querySelectorAll('.rp-filter[data-key="' + filter.dataset.key + '"]')
          .forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        filter.setAttribute('aria-pressed', 'true');
      } else {
        var all = filter.parentElement.querySelector('.rp-filter[data-key="' + filter.dataset.key + '"][data-value="*"]');
        if (all) all.setAttribute('aria-pressed', 'false');
        filter.setAttribute('aria-pressed', String(!pressed));
      }
      applyFilters(filter.closest('.rp-filters'));
    }
  });
})();
